<template>
    <div class="animated fadeIn">
        <b-card>
            <b-card-body>
                <div id="vouchers">
                    <b-row>
                        <b-col md="6">
                            <b-form-group label="Дата оформления: " :label-cols="3" :horizontal="false">
                                <div class="input-group">
                                    <v-date-picker
                                        id="rangeCRSelect"
                                        mode='range'
                                        v-model='rangeCRFilter'
                                        @change="applyRangeCRFilter()"
                                        @input="applyRangeCRFilter()"
                                        :attributes="datepicker_attributes"
                                    >
                                        <b-form-input
                                            type="text"
                                            id="rangeCRSelect_input"
                                            slot-scope="{ inputProps, inputEvents, isDragging }"
                                            class="form-control form-date-picker"
                                            readonly
                                            v-bind="inputProps"
                                            v-on="inputEvents" />
                                    </v-date-picker>
                                    <b-button type="button" variant="secondary"  @click='resetRangeCRFilter()'><i class="cui-circle-x icon"></i> </b-button>
                                </div>
                            </b-form-group>

                            <b-form-group label="Дата заезда: " :label-cols="3" :horizontal="false">
                                <div class="input-group">
                                    <v-date-picker
                                        id="rangeCISelect"
                                        mode='range'
                                        v-model='rangeCIFilter'
                                        @change="applyRangeCIFilter()"
                                        @input="applyRangeCIFilter()"
                                        :attributes="datepicker_attributes"
                                    > <b-form-input
                                        type="text"
                                        id="rangeCISelect_input"
                                        slot-scope="{ inputProps, inputEvents, isDragging }"
                                        class="form-control form-date-picker"
                                        readonly
                                        v-bind="inputProps"
                                        v-on="inputEvents" />
                                    </v-date-picker>
                                    <b-button type="button" variant="secondary"  @click='resetRangeCIFilter()'><i class="cui-circle-x icon"></i> </b-button>
                                </div>
                            </b-form-group>

                            <b-form-group label="Дата выезда: " label-for="rangeSelect" :label-cols="3" :horizontal="false">
                                <div class="input-group">
                                    <v-date-picker
                                        id="rangeCOSelect"
                                        mode='range'
                                        v-model='rangeCOFilter'
                                        @change="applyRangeCOFilter()"
                                        @input="applyRangeCOFilter()"
                                        :attributes="datepicker_attributes"
                                    >

                                        <b-form-input
                                            type="text"
                                            id="rangeSelect_input"
                                            slot-scope="{ inputProps, inputEvents, isDragging }"
                                            class="form-control form-date-picker"
                                            readonly
                                            v-bind="inputProps"
                                            v-on="inputEvents" />
                                    </v-date-picker>
                                    <b-button type="button" variant="secondary"  @click='resetRangeCOFilter()'><i class="cui-circle-x icon"></i> </b-button>
                                </div>
                            </b-form-group>

                            <b-form-group label="Дата выполнения: " :label-cols="3" :horizontal="false" description="дата, до которой должно быть выполнено действие, закрывающее текущий статус">
                                <div class="input-group">
                                    <v-date-picker
                                        id="rangeSCSelect"
                                        mode='range'
                                        v-model='rangeSCFilter'
                                        @change="applyRangeSCFilter()"
                                        @input="applyRangeSCFilter()"
                                        :attributes="datepicker_attributes"
                                    >
                                        <b-form-input
                                            type="text"
                                            id="rangeSCSelect_input"
                                            slot-scope="{ inputProps, inputEvents, isDragging }"
                                            class="form-control form-date-picker"
                                            readonly
                                            v-bind="inputProps"
                                            v-on="inputEvents" />
                                    </v-date-picker>
                                    <b-button type="button" variant="secondary"  @click='resetRangeSCFilter()'><i class="cui-circle-x icon"></i> </b-button>
                                </div>
                            </b-form-group>

                            <b-form-group label="Просроченные" :label-cols="3" :horizontal="false" description="показывать только путевки у которых дата выполнения необходимого действия прошла">
                                <div class="custom-control custom-checkbox custom-control-inline" @change='overduedChanged()'>
                                    <input type="checkbox" class="custom-control-input" id="overdueFilter" value="1" v-model="overduedFilter">
                                    <label class="custom-control-label" for="overdueFilter">только просроченные путевки</label>
                                </div>
                            </b-form-group>

                            <b-form-group label="Квоты" :label-cols="3" :horizontal="false" description="показывать только путевки с флагом 'Квота'">
                                <div class="custom-control custom-checkbox custom-control-inline" @change='quotaChanged()'>
                                    <input type="checkbox" class="custom-control-input" id="quotaFilter" value="1" v-model="quotaFilter">
                                    <label class="custom-control-label" for="quotaFilter">только путевки с флагом 'Квота'</label>
                                </div>
                            </b-form-group>

                            <b-form-group label="Ростуризм" :label-cols="3" :horizontal="false" description="показывать только путевки с флагом 'Ростуризм'">
                                <div class="custom-control custom-checkbox custom-control-inline" @change='rosturizmChanged()'>
                                    <input type="checkbox" class="custom-control-input" id="rosturizmFilter" value="1" v-model="rosturizmFilter">
                                    <label class="custom-control-label" for="rosturizmFilter">только путевки с флагом 'Ростуризм'</label>
                                </div>
                            </b-form-group>

                        </b-col>
                        <b-col md="6">

                            <b-form-group label="Статус путевки: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                                <b-form-select id="basicSelect"
                                               @change="applyStatusFilter()"
                                               :plain="true"
                                               v-model="statusFilter"
                                               :options="CONSTANTS.VOUCHER_STATE_NAMES"
                                               value="Please select">
                                </b-form-select>
                            </b-form-group>

                            <b-form-group label="Агентство: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                                <div class="input-group">
                                    <b-form-select id="basicSelect"
                                                   @change="applyCompanyFilter()"
                                                   :plain="true"
                                                   v-model="companyFilter"
                                                   :options="getMainCompanies()"
                                                   value-field="id"
                                                   text-field="title"
                                                   value="Please select">
                                    </b-form-select>
                                    <b-button type="button" variant="secondary" @click="resetCompanyFilter()"> <i class="cui-circle-x icon "></i></b-button>
                                </div>
                            </b-form-group>

                            <b-form-group label="Юр/лицо агентства: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                                <div class="input-group">
                                    <b-form-select id="basicSelect"
                                                   @change="applyDocCompanyFilter() "
                                                   :plain="true"
                                                   v-model="docCompanyFilter"
                                                   :options="getDocCompanies()"
                                                   value-field="id"
                                                   text-field="title"
                                                   value="Please select">
                                    </b-form-select>
                                    <b-button type="button" variant="secondary" @click="resetDocCompanyFilter()"> <i class="cui-circle-x icon "></i></b-button>
                                </div>
                            </b-form-group>

                            <b-form-group label="Агент: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                                <div class="input-group">
                                    <b-form-select id="basicSelect"
                                                   @change="applyUserFilter() "
                                                   :plain="true"
                                                   v-model="userFilter"
                                                   :options="getUsers()"
                                                   value-field="id"
                                                   text-field="full_name"
                                                   value="Please select">
                                    </b-form-select>
                                    <b-button type="button" variant="secondary" @click="resetUserFilter()"> <i class="cui-circle-x icon "></i></b-button>
                                </div>
                            </b-form-group>

                            <b-form-group label="Заказчик/турист: " :label-cols="3" :horizontal="false   ">
                                <div class="input-group">
                                    <b-form-input v-model="clientFilter" @input="throttle(1, 2007, applyClientFilter)" />
                                    <b-button type="button" variant="secondary"  @click='resetClientFilter()'><i class="cui-circle-x icon"></i> </b-button>
                                </div>
                            </b-form-group>

                            <b-form-group label="Контакты: " :label-cols="3" :horizontal="false   ">
                                <div class="input-group">
                                    <b-form-input v-model="contactsFilter" @input="throttle(1, 2007, applyContactsFilter)" />
                                    <b-button type="button" variant="secondary"  @click='resetContactsFilter()'><i class="cui-circle-x icon"></i> </b-button>
                                </div>
                            </b-form-group>

                        </b-col>
                    </b-row>
                    <v-server-table :url="apiurl('voucher/table')"  :columns="columns" :options="options" :theme="theme" id="vouchersTable" ref="vouchersTable"  >

                        <span slot="id" slot-scope="props">
                            <a  :href="$router.resolve({ path:voucherPage(props.row.id)}).href">{{props.row.id}}</a>
                            <br /><small>{{CONSTANTS.VOUCHER_STATE_NAMES[props.row.status_index]}}</small>
                            <template v-if="checkVoucherSums(props.row)">
                                <br /><span class="alert-danger small">суммы не сходятся</span>
                            </template>
                        </span>

                        <span slot="status_changed_at" slot-scope="props" v-html="x_date(props.row)"></span>

                        <span slot="company_and_user" slot-scope="props">
                            <span class="vouchers_table__user">#{{ props.row.user_id}} {{  props.row.user_firstname }} {{ props.row.user_lastname }} ({{ props.row.user_login }})</span><br />
                            <span class="vouchers_table__company">#{{ props.row.company_id  }} {{ props.row.company_title }}</span>
                            <template v-if="props.row.company_id !== props.row.doc_company_id">
                                <br /><span>#{{ props.row.doc_company_id }} {{ props.row.doc_company_title }}</span>
                            </template>
                        </span>

                        <span slot="person" slot-scope="props">
                            <strong v-if="!props.row.customer_id">
                                {{ props.row.contact_name }}
                            </strong>
                            <strong v-if="props.row.customer_id">
                                {{ customerTitle(props.row.customer) }}
                                <small v-if="customerSubtitle(props.row.customer)"><br/>{{ customerSubtitle(props.row.customer) }}</small>
                            </strong>
                            <template v-for="guest in  props.row.guests">
                                <small><br/>{{ guest.surname }} {{ guest.name_ }} {{ guest.patro }}</small>
                            </template>
                        </span>

                        <span slot="hotel" slot-scope="props">
                            <template v-if="is(props.row.hotel)"><strong>{{ props.row.hotel.title }}</strong><br></template>
                            <template v-if="is(props.row.city)"><small>{{ props.row.city.title }}</small></template>
                        </span>

                        <span slot="summa_full" slot-scope="props">
                            {{ formatPriceKop(props.row.summa_full) }}
                        </span>

                        <div slot="child_row" slot-scope="props">
                            <h3>Путевка № {{props.row.id}}</h3>

                            <b-button type="button" size="sm" variant="success"  :to="{ path: '/admin/voucher/'+props.row.id, params: { voucher_id: props.row.id }}">
                                <i class="fa fa-edit"></i> Просмотр/редактирование путевки
                            </b-button>&nbsp;

                            <br/><br/>

                            <b-button variant="secondary" @click="printContract(props.row, false);" :disabled="!canSmPrintContract(props.row)"><i class="fa fa-print"></i> Договор</b-button>
                            <b-button variant="secondary" @click="printVoucher(props.row, false)" :disabled="!canSmPrintVoucher(props.row)"><i class="fa fa-print"></i> Обменная путевка</b-button>
                            <b-button variant="secondary" @click="printInvoice(props.row, false)" :disabled="!canSmPrintInvoice(props.row)" v-if="is_agent_or_agency||is_admin"><i class="fa fa-print"></i> Счет</b-button>
                            <b-button variant="secondary" @click="printCheckinList(props.row)" :disabled="!canSmPrintCheckinList(props.row)"><i class="fa fa-print"></i> Лист заезжающего</b-button>
                            <b-button variant="secondary" @click="printVst(props.row)" :disabled="!canSmPrintCheckinList(props.row)"><i class="fa fa-print"></i> Баннер для встречи</b-button>
                            <b-button variant="secondary" @click="printCalc(props.row)" :disabled="!canSmPrintInvoice(props.row)"><i class="fa fa-print"></i> Калькуляция</b-button>
                            <b-button variant="secondary" @click="printHotelBookRequest(props.row)" :disabled="!canSmPrintHotelRequest(props.row)"><i class="fa fa-print"></i> Заявка</b-button>
                            <b-button variant="secondary" @click="printHotelChangeRequest(props.row)" :disabled="!canSmPrintHotelChange(props.row)"><i class="fa fa-print"></i> Корректировка</b-button>
                            <b-button variant="secondary" @click="printHotelCancelRequest(props.row)" :disabled="!canSmPrintHotelCancel(props.row)"><i class="fa fa-print"></i> Аннуляция</b-button>

                        </div>
                    </v-server-table>
                </div>
            </b-card-body>
        </b-card>
        <b-modal :title="'Удаление путевки #'+ voucherIdToDelete" class="modal-danger" centered  v-model="deleteModal" @ok="continueDelete()" @cancel="cancelDelete()" @hide="cancelDelete()" ok-variant="danger">
            Вы собираетесь удалить путевку. Эта операция может привести к непопправимым последствиям,
            и вам сдедует хорошо подумать, прежде чем делать это.
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                <b>Ваше решение:</b>
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Отказаться
                </b-button>
                <b-button size="sm" variant="danger" @click="ok()">
                    Продолжить удаление
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_company } from '@/functions/company.js';
    import { functions_vouchers_view } from '@/functions_vouchers_view.js';
    import { functions_customers } from '@/functions_customers.js';
    import { functions_voucher } from '@/functions_voucher.js';
    import { functions_voucher_print } from '@/functions_voucher_print.js';
    import { sm_functions } from '@/sm_functions.js';
    import { sm_conditions } from '@/sm_conditions.js';


    import VueJsonPretty from 'vue-json-pretty'
    import date_end_iso  from '../jsx/vouchers/date_end_iso'
    import contact_name  from '../jsx/vouchers/contact_name'
    import {CONSTANTS} from '@/constants';
    //import { setupCalendar, DatePicker } from 'v-calendar'
    //import 'v-calendar/lib/v-calendar.min.css'

    Vue.use(ServerTable)

    const today = new Date()

    export default {
        name: 'NsbAdminVouchers',
        components: {
            ServerTable,
            Event,
            VueJsonPretty,
        },
        mixins: [functions, functions_loaders, functions_vouchers_view, functions_voucher, functions_voucher_print,
            sm_functions, sm_conditions, functions_customers, functions_company],
        data: function () {
            return {
                columns: ['id', 'date_end_iso', 'status_changed_at', 'person', 'hotel', 'company_and_user', 'summa_full',  ],
                options: {
                    saveState: true,
                    headings: {
                        id: '#',
                        date_end_iso: 'даты',
                        person: 'заказчик/туристы',
                        hotel: 'объект/город',
                        company_and_user: 'агентство',
                        status_index: 'Статус',
                        summa_full: 'Стоимость',
                        status_changed_at: 'Статус изменен/Надо закрыть'
                    },
                    templates: {
                        date_end_iso,
                    },
                    sortable: [
                        'id',
                        'date_end_iso',
                        'summa_full',
                        'summa_fact_payment',
                    ],
                    dateColumns:[],
                    filterable: ['id', 'contact_name', 'summa_full', 'summa_fact_payment' ],
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll',
                        dropdown:false
                    },
                    customFilters: [
                        'status',
                        'rangeco',
                        'rangeci',
                        'rangecr',
                        'rangesc',
                        'company',
                        'doccompany',
                        'user',
                        'contacts',
                        'company',
                        'hotel',
                        'client',
                        'overdued',
                        'quota',
                        'rosturizm'
                    ],
                    initFilters: {
                        rangeco:this.$store.state.voucherFilters.rangeCOFilter,
                        rangeci:this.$store.state.voucherFilters.rangeCIFilter,
                        rangecr:this.$store.state.voucherFilters.rangeCRFilter,
                        rangesc:this.$store.state.voucherFilters.rangeSCFilter,
                        status:this.$store.state.voucherFilters.statusFilter,
                        doccompany:this.$store.state.voucherFilters.docCompanyFilter,
                        user:this.$store.state.voucherFilters.userFilter,
                        contacts:this.$store.state.voucherFilters.contactsFilter,
                        company:this.$store.state.voucherFilters.companyFilter,
                        hotel:this.$store.state.voucherFilters.hotelFilter,
                        client:this.$store.state.voucherFilters.clientFilter,
                        overdued:this.$store.state.voucherFilters.overduedFilter,
                        quota:this.$store.state.voucherFilters.quotaFilter,
                        rosturizm:this.$store.state.voucherFilters.rosturizmFilter,
                    },
                    perPageValues:[],

                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    rowClassCallback: this.latestVoucherClass,
                    columnsClasses: {
                        summa_full: "right",
                    },
                },
                theme: 'bootstrap4',
                template: 'default',
                deleteModal: false,
                voucherIdToDelete:null,
                deletedVoucherId:null,
            }
        },
        methods: {
            getUsers: function () {
                return this.users;
            },
            getDocCompanies: function () {
                return this.companies;
            },
            getMainCompanies: function () {
                return this.companies;
            },

            saveFilter: function() {
                this.$store.commit('saveVoucherFilters', {
                    statusFilter:this.statusFilter,
                    companyFilter:this.companyFilter,
                    docCompanyFilter:this.docCompanyFilter,
                    userFilter:this.userFilter,
                    contactsFilter:this.contactsFilter,
                    clientFilter:this.clientFilter,
                    rangeCOFilter:this.rangeCOFilter,
                    rangeCIFilter:this.rangeCIFilter,
                    rangeCRFilter:this.rangeCRFilter,
                    rangeSCFilter:this.rangeSCFilter,
                    overduedFilter:this.overduedFilter,
                    quotaFilter:this.quotaFilter,
                    rosturizmFilter:this.rosturizmFilter,
                });
            },

            restoreFilter: function() {
                this.statusFilter = this.$store.state.voucherFilters.statusFilter;
                if (!this.statusFilter) this.statusFilter=CONSTANTS.VOUCHER_STATE_UNKNOWN;

                this.companyFilter = this.$store.state.voucherFilters.companyFilter;
                if (!this.companyFilter) this.companyFilter=null;

                this.docCompanyFilter = this.$store.state.voucherFilters.docCompanyFilter;
                if (!this.docCompanyFilter) this.docCompanyFilter=null;

                this.userFilter = this.$store.state.voucherFilters.userFilter;
                if (!this.userFilter) this.userFilter=null;

                this.contactsFilter = this.$store.state.voucherFilters.contactsFilter;
                if (!this.contactsFilter) this.contactsFilter=null;

                this.clientFilter = this.$store.state.voucherFilters.clientFilter;
                if (!this.clientFilter) this.clientFilter=null;

                this.rangeCOFilter = Object.assign({}, this.$store.state.voucherFilters.rangeCOFilter);
                if (!this.rangeCOFilter) this.rangeCOFilter=null;

                this.rangeCIFilter = Object.assign({}, this.$store.state.voucherFilters.rangeCIFilter);
                if (!this.rangeCIFilter) this.rangeCIFilter=null;

                this.rangeCRFilter = Object.assign({}, this.$store.state.voucherFilters.rangeCRFilter);
                if (!this.rangeCRFilter) this.rangeCRFilter=null;

                this.rangeSCFilter = Object.assign({}, this.$store.state.voucherFilters.rangeSCFilter);
                if (!this.rangeSCFilter) this.rangeSCFilter=null;

                this.overduedFilter = this.$store.state.voucherFilters.overduedFilter;
                if (!this.overduedFilter) this.overduedFilter=false;

                this.quotaFilter = this.$store.state.voucherFilters.quotaFilter;
                if (!this.quotaFilter) this.quotaFilter=false;

                this.rosturizmFilter = this.$store.state.voucherFilters.rosturizmFilter;
                if (!this.rosturizmFilter) this.rosturizmFilter=false;

            },
        },
        computed: {

        },
        created: function() {
            this.loadCompanies();
            this.loadUsers();
        },
        mounted: function () {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
            this.restoreFilter();
        },
        notifications: {
        }
    };
</script>

<style lang="scss">

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
